import React, { useState, useEffect } from 'react';
import { Button, Container, FormControl, InputLabel, Select, MenuItem, Box, Modal, TextField, AppBar, Toolbar, Paper, Typography, Tooltip } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

const EditCity = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [cityName, setCityName] = useState('');
  const [stateId, setStateId] = useState('');
  const [countryId, setCountryId] = useState('');
  const { cityId } = useParams();
  const navigate = useNavigate();

  // Static data for countries and states
  const staticCountryData = [
    { countryId: 1, countryName: 'India' },
  ];

  const staticStateData = [
    { stateId: 1, stateName: 'Bihar' },
    { stateId: 2, stateName: 'Jharkhand' },
  ];

  // Static city data to pre-fill based on cityId from City component
  const staticCityData = [
    { cityId: 1, countryId: 1, stateId: 1, cityName: 'Patna' },
    { cityId: 2, countryId: 1, stateId: 2, cityName: 'Bokaro' },
    { cityId: 3, countryId: 1, stateId: 1, cityName: 'Darbhanga' },
    { cityId: 4, countryId: 1, stateId: 1, cityName: 'Manpur' },
    { cityId: 5, countryId: 1, stateId: 1, cityName: 'Nauranga' },
  ];

  useEffect(() => {
    const city = staticCityData.find(city => city.cityId === parseInt(cityId));
    if (city) {
      setCityName(city.cityName);
      setStateId(city.stateId);
      setCountryId(city.countryId);
    } else {
      alert('City not found');
    }
  }, [cityId]);

  const handleUpdate = () => {
    if (cityName) {
      setShowSuccessModal(true);
    } else {
      alert('Please enter a city name');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container mt={4}>
     <Box
               sx={{
                 backgroundColor: 'rgba(2, 78, 101, 1)', 
                 padding: '12px 16px',
                 boxShadow: 3,
                 borderRadius: '4px 4px 0 0',
                 margin: '2px auto',
                width: "100%",
               }}
             >
               <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit City
           </Typography> </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor:'#f8fdfeff' }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="country">Country:</InputLabel>
            <Select
              id="country"
              value={countryId}
              label="Country"
              onChange={(e) => setCountryId(e.target.value)}
              
            >
              {staticCountryData.map((countryItem) => (
                <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                  {countryItem.countryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="state">State:</InputLabel>
            <Select
              id="state"
              value={stateId}
              label="State"
              onChange={(e) => setStateId(e.target.value)}
              
            >
              {staticStateData.map((stateItem) => (
                <MenuItem key={stateItem.stateId} value={stateItem.stateId}>
                  {stateItem.stateName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="City Name"
            variant="outlined"
            fullWidth
            value={cityName}
            onChange={(e) => setCityName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!cityName && "Enter City Name"} arrow>
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdate}
                sx={{ mr: 2, 
                       backgroundColor: '#127498ff',
                '&:hover': { backgroundColor: '#116280ff' },
                }}
                disabled={!cityName}
              >
                Update
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
           data-app-cancel="true">
            Cancel
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              City Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              City Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditCity;